export class PlcError extends Error {
	public keyOrMessage: string;

	constructor(keyOrMessage: string) {
		super();
		this.keyOrMessage = keyOrMessage;
	}
}
